import React, { useState, useEffect } from 'react';
import iconQFlowSmall from '../assets/icon-qflow-small.png';
import {
  LayoutDashboard,
  ShoppingBag,
  ShoppingCart,
  GitMerge,
  AlertTriangle,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Users,
  MessageCircle,
  Megaphone
} from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { UserService } from '../services/userService';

// Definição dos itens do menu que estava faltando
const menuItems = [
  { icon: LayoutDashboard, label: 'Dashboard',     path: '/dashboard' },
  { icon: ShoppingBag,    label: 'Catálogo',       path: '/catalog' },
  { icon: ShoppingCart,   label: 'Pedidos',        path: '/orders' },
  { icon: MessageCircle,  label: 'Perguntas',      path: '/questions' },
  { icon: Megaphone,      label: 'Campanhas',      path: '/campaigns' },
  { icon: GitMerge,       label: 'Mapeamento',     path: '/mapping',        hidden: true },
  { icon: AlertTriangle,  label: 'Erros',          path: '/troubleshooting', hidden: true },
  { icon: Users,          label: 'Minhas Indicações',  path: '/influencer-clients' },
  { icon: Settings,       label: 'Configurações',  path: '/settings' },
];

export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [userName, setUserName] = useState('Usuário');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const storedData = localStorage.getItem('user_info');
    if (storedData) {
      try {
        const user = JSON.parse(storedData);
        // Usa a coluna 'nome' ou 'username' retornada pelo serviço
        setUserName(user.nome || user.username || user.usuario || 'Usuário');
      } catch (e) {
        console.error("Erro ao processar dados do usuário", e);
      }
    }
  }, []);

  // Gera abreviação (ex: Marcos Machado -> MM)
  const getInitials = (name: string) => {
    if (!name) return 'U';
    return name
        .split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .substring(0, 2);
  };

  const handleLogout = () => {
    UserService.logout();
    navigate('/login');
  };

  return (
      <aside
          style={{ background: 'linear-gradient(180deg, #4E2FCE 0%, #3D22B0 100%)' }}
          className={`border-r border-primary-700/40 transition-all duration-300 flex flex-col ${isCollapsed ? 'w-20' : 'w-64'}`}
      >
        <div className="p-6 flex items-center justify-between">
          <img
              src={iconQFlowSmall}
              alt="QFlow"
              style={{ width: isCollapsed ? 32 : 40, height: isCollapsed ? 32 : 40 }}
          />
          <button
              onClick={() => setIsCollapsed(!isCollapsed)}
              className="p-2 hover:bg-white/10 rounded-lg text-white/60 hover:text-white transition-colors"
          >
            {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
          </button>
        </div>

        <nav className="flex-1 px-4 space-y-1">
          {menuItems.filter(item => !item.hidden).map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
                <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center gap-3 p-3 rounded-lg transition-colors ${
                        isActive
                            ? 'bg-white/20 text-white font-semibold'
                            : 'text-white/65 hover:bg-white/10 hover:text-white'
                    }`}
                >
                  <Icon size={22} />
                  {!isCollapsed && <span className="font-medium">{item.label}</span>}
                </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-white/15">
          <div className={`flex items-center gap-3 ${isCollapsed ? 'justify-center' : 'px-2'}`}>
            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white font-bold shrink-0 border border-white/30">
              {getInitials(userName)}
            </div>
            {!isCollapsed && (
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-white truncate">{userName}</p>
                </div>
            )}
          </div>
          <button
              onClick={handleLogout}
              className={`w-full mt-4 flex items-center gap-3 p-3 text-white/50 hover:bg-white/10 hover:text-red-300 rounded-lg transition-colors ${
                  isCollapsed ? 'justify-center' : ''
              }`}
          >
            <LogOut size={22} />
            {!isCollapsed && <span className="font-medium">Sair</span>}
          </button>
        </div>
      </aside>
  );
}
